import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HeroSectionSchema } from '../types/HeroSectionSchema';

const initialState: HeroSectionSchema = {
    
};

export const HeroSectionSlice = createSlice({
    name: 'HeroSection',
    initialState,
    reducers: {
        template: (state, action: PayloadAction<string>) => {
           
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(, (state) => {
    //             state.error = undefined;
    //             state.isLoading = true;
    //         })
    //         .addCase(, (state) => {
    //             state.isLoading = false;
    //         })
    //         .addCase(, (state, action) => {
    //             state.isLoading = false;
    //             state.error = action.payload;
    //         });
    // },
});

export const { actions: HeroSectionActions } = HeroSectionSlice;
export const { reducer: HeroSectionReducer } = HeroSectionSlice;